import { useState, useRef, useEffect } from "react";
import styles from "./LanguageSwitcher.module.scss";
import { ChevronDown } from "lucide-react";

export default function LanguageSwitcher({ currentLang, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const languages = [
    { code: "pl", label: "Polski", flag: "🇵🇱" },
    { code: "en", label: "English", flag: "🇬🇧" },
  ];

  const activeLang = languages.find((lang) => lang.code === currentLang);

  return (
    <div className={styles.wrapper} ref={ref}>
      <button
        className={styles.trigger}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className={styles.flag}>{activeLang.flag}</span>
        <ChevronDown className={styles.icon} />
      </button>

      {open && (
        <div className={styles.dropdown}>
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={styles.option}
              onClick={() => {
                onChange(lang.code);
                setOpen(false);
              }}
            >
              <span className={styles.flag}>{lang.flag}</span>
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
